import { SvgIcon, SvgIconProps } from '@mui/material';

export function InformationCircle({ sx = {}, ...props }: SvgIconProps) {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      sx={{ ...sx, fill: 'none' }}
    >
      <g clipPath="url(#clip0_2992_2471)">
        <path
          d="M9.99984 6.66699V7.50033M9.99984 9.58366V13.3337M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39747 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39747 18.3337 9.99984 18.3337Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2992_2471">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default InformationCircle;
